import React from 'react'

import { useTranslation } from 'language/translator'
import { useKeyMetric } from 'redux/hooks/KeyMetrics'
import { useParams } from 'utils/hooks'

import {
  BreadcrumbsProps,
  TBreadcrumbItem
} from 'components_new/molecules/Breadcrumbs'

import KeyMetricNavigation from 'components_new/organisms/KeyMetricNavigation'

import PageLayout, {
  PageLayoutProps
} from 'components_new/templates/PageLayout'

interface KeyMetricTemplateProps
  extends Omit<PageLayoutProps, 'rightSidebar' | 'topbar'> {
  topbar?: Pick<NonNullable<PageLayoutProps['topbar']>, 'actions'>
  rightSidebar?: Pick<
    NonNullable<PageLayoutProps['rightSidebar']>,
    'collapsed' | 'content' | 'setCollapsed' | 'size'
  >
  subpage?: TBreadcrumbItem
}

const KeyMetricTemplate = (props: KeyMetricTemplateProps) => {
  const { children, rightSidebar, subpage, topbar, ...rest } = props

  const { id } = useParams()
  const keyMetric = useKeyMetric(id)
  const { t } = useTranslation()

  const breadcrumbs: BreadcrumbsProps['items'] = [
    {
      href: '/key-metrics',
      icon: { name: 'KeyMetrics' },
      title: t('key_metrics', 'key_metrics')
    }
  ]

  if (keyMetric) {
    breadcrumbs.push({
      href: `/key-metrics/${keyMetric.id}`,
      title: keyMetric.title
    })
  }

  if (subpage) {
    breadcrumbs.push(subpage)
  }

  return (
    <PageLayout
      rightSidebar={{
        collapsed: rightSidebar?.collapsed,
        content: rightSidebar?.content,
        navigation: <KeyMetricNavigation />,
        size: rightSidebar?.size ?? 'small',
        setCollapsed: rightSidebar?.setCollapsed
      }}
      topbar={{
        actions: topbar?.actions,
        breadcrumbs: breadcrumbs,
        mobile: {
          goBack: true
        }
      }}
      {...rest}
    >
      {children}
    </PageLayout>
  )
}

export default KeyMetricTemplate
